<template>
  <section class="app-aproc">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title"
              >Validação de Certificado</v-card-title
            >
            <v-card-text class="app-card-content">
              <v-alert outlined type="info" text
                >Abaixo é possível validar o certificado inserindo o código
                validador.
              </v-alert>
              <br />
              <v-form
                ref="form"
                v-model="formModel.valid"
                lazy-validation
                @submit.prevent="onSubmit"
              >
                <v-row>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-text-field
                      type="text"
                      label="Código validador"
                      placeholder="Ex.: GDX1B34648GA"
                      v-model="formModel.codigoValidador"
                      :rules="[rules.required]"
                      class="codigoValidador"
                      filled
                      rounded
                      dense
                      append-icon="search"
                    ></v-text-field>
                  </v-col>
                  <v-col :md="9" :sm="9" :xs="12" cols="12">
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="siteKey"
                      :loadRecaptchaScript="true"
                      @verify="verifyRecaptcha"
                      @expired="expiredRecaptcha"
                      class="recaptcha"
                    ></vue-recaptcha>
                    <v-input
                      v-model="formModel.recaptcha"
                      type="hidden"
                      :rules="[rules.required]"
                      style="margin-top: -25px;"
                    ></v-input>
                  </v-col>
                  <v-col :md="3" :sm="3" :xs="12" cols="12">
                    <v-btn depressed block large color="primary" type="submit"
                      >Continuar</v-btn
                    >
                  </v-col>
                </v-row>
              </v-form>
              <div class="text-xs-center area-loading" v-if="isLoading">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  :size="20"
                  :width="2"
                ></v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
          <div id="certificate-valid"></div>
          <v-card outlined class="app-card" v-if="certificado">
            <v-card-title class="app-card-title">
              Certificado
            </v-card-title>

            <v-card-text class="app-card-content">
              <v-row no-gutters>
                <v-col :md="12" :sm="12" :xs="12" cols="12">
                  <strong class="info-text">
                    Contribuinte:
                    <em>{{ certificado.contribuinte }}</em>
                  </strong>
                </v-col>

                <v-col
                  :md="12"
                  :sm="12"
                  :xs="12"
                  cols="12"
                  class="mt-2 text-md-left"
                  v-if="certificado && certificado.placa"
                >
                  <strong class="info-text">
                    Placa:
                    <em>{{ certificado.placa }}</em>
                  </strong>
                </v-col>

                <v-col
                  :md="12"
                  :sm="12"
                  :xs="12"
                  cols="12"
                  class="mt-2 text-md-left"
                >
                  <strong class="info-text">
                    Validade:
                    <em>{{ certificado.validade }}</em>
                  </strong>
                </v-col>

                <v-col
                  :md="12"
                  :sm="12"
                  :xs="12"
                  cols="12"
                  class="mt-2 text-md-left"
                >
                  <strong class="info-text">
                    Codigo validador:
                    <em>{{ certificado.hash }}</em>
                  </strong>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import { mask } from "vue-the-mask";
import TransportadoraAuthService from "@/services/transportadora.auth.service";
import ValidaCertificadoService from "@/services/validaCertificado.service";

export default {
  components: {
    VueRecaptcha
  },
  directives: {
    mask
  },
  metaInfo: {
    title: "Validação de Certificado - Central de Serviços"
  },
  data() {
    return {
      siteKey: VUE_APP_RECAPTCHA_KEY,
      isLoading: false,
      transportadora: null,
      certificado: null,
      formModel: {
        codigoValidador: null,
        recaptcha: null
      },
      valid: false,
      rules: {
        required: value => !!value || "Esse campo deve ser preenchido"
      }
    };
  },
  methods: {
    verifyRecaptcha(value) {
      this.formModel.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.formModel.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        const { codigoValidador } = this.formModel;
        this.isLoading = true;
        this.$router.push({
          name: "detalhe-certificado",
          params: { codigoValidador: codigoValidador }
        });
      }
    }
  }
};
</script>

<style></style>
